import { type User } from '../resources/User/types';
import { GroupChannel } from '@sendbird/chat/groupChannel';

/**
 * Returns channel name if it was set by the user, if not, returns the `string` with the nicknames of the members of the channel.
 */
export const getChatChannelName = (
  channel: GroupChannel | undefined,
  currentUser: User
): string => {
  if (!channel || !channel.name) return '';

  if (channel.name.length > 0) {
    return channel.name;
  }

  const membersExcludingCurrentUser = channel.members.filter(
    (m) => m.userId !== currentUser.id.toString()
  );

  if (membersExcludingCurrentUser.length > 3) {
    return (
      membersExcludingCurrentUser
        .slice(0, 3)
        .map((m) => m.nickname)
        .join(', ') + '...'
    );
  }

  return membersExcludingCurrentUser.map((m) => m.nickname).join(', ');
};
